import React from "react";
import { ClipLoader, PulseLoader } from "react-spinners";
import player from "../../assets/player1.png";
import { LoadingType } from "../../types/LoadingTypes";
import { LoaderImage } from "./LoadingStyles";

type LoaderProps = {
  type: LoadingType;
  size?: string;
};

const Loader: React.FC<React.PropsWithChildren<LoaderProps>> = ({ type = "mlb", size = "" }) => {
  const getLoader = () => {
    switch (type) {
      case "spinner":
        return <ClipLoader size={size} />;
      case "pulse":
        return <PulseLoader size={size} />;
      case "player":
        return <LoaderImage src={player} width={!!size ? size : "70px"} />;
      case "mlb":
      default:
        return (
          <LoaderImage
            src="https://www.mlbstatic.com/team-logos/league-on-light/1.svg"
            width={!!size ? size : "120px"}
          />
        );
    }
  };

  return getLoader();
};

export default Loader;
